// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1z9ei","requiredAsterisk":"Info_requiredAsterisk__3TPKO"};